<template>
  <NovaRequisicaoMaterialComponent
    :category="1"
    :title="'Requisição Material EPIs'"
  />
</template>

<script>
import NovaRequisicaoMaterialComponent from "../components/NovaRequisicaoMaterialComponent.vue";
export default {
  components: {
    NovaRequisicaoMaterialComponent,
  },
};
</script>

<style></style>
